// 斑斑驾道学员端接口
import axios from '@/utils/axios'
const api = {
  pickUp: {},
  appointment: {}
};

/**
 * @name 获取学员接送记录
 * @param res
 */
api.pickUp.getPickUpRecord = res => axios({
  method: 'GET',
  url: '/zjerp/outer/studentPickUp/pickUpRecord',
  params: res
});

/**
 * @name 学员自主取消接送
 * @param res  -预约记录ID
 */
api.pickUp.cancelPickUpForStudent = res => axios({
  method: 'GET',
  url: '/zjerp/outer/studentPickUp/cancelPickUpForStudent',
  params: res
});

/**
 * @name 通过预约记录ID查询预约详情和接送线路列表
 * @param res  -预约记录ID
 */
api.pickUp.getPickUpAddress = res => axios({
  method: 'GET',
  url: '/zjerp/outer/studentPickUp/pickUpAddress',
  params: res
});

/**
 * @name 学员根据预约记录选择接送点
 * @param data  -预约记录ID
 */
api.pickUp.selectAddress = data => axios({
  method: 'POST',
  url: '/zjerp/outer/studentPickUp/selectAddress',
  data
});

/**
 * @name 根据学员获取调用新接口还是旧接口
 * @param res
 */
api.appointment.getCoachJumpType = res => axios({
  method: 'GET',
  url: '/zjerp/outer/coach/v1/getCoachJumpType',
  params: res
});

/**
 * @name 获取分配类型
 * @param res
 */
api.appointment.getUserCoachType = res => axios({
  method: 'GET',
  url: '/zjerp/outer/coach/v1/getUserCoachType',
  params: res
});

/**
 * @name 混合带教获取教练
 * @param res
 */
api.appointment.getListUserCoach = res => axios({
  method: 'GET',
  url: '/zjerp/outer/coach/v1/getListUserCoach',
  params: res
});

/**
 * @name 原获取教练信息
 * @param res
 */
api.appointment.getUserCoachNew = res => axios({
  method: 'POST',
  url: '/zjerp/outer/coach/v1/getUserCoachNew',
  data: res
});

/**
 * @name 获取学员教练
 * @param res
 */
api.appointment.getUserCoach = res => axios({
  method: 'GET',
  url: '/zjerp/outer/coach/v1/getUserCoach',
  params: res
});

/**
 * @name 查询约车排班日期列表
 * @param res -教练ID/开始时间/结束时间
 */
api.appointment.queryAppointmentCarDateByDate = res => axios({
  method: 'POST',
  url: '/zjerp/outer/planClassCar/v1/queryAppointmentCarDateByDate',
  data: res
});

/**
 * @name 查询约车排班列表
 * @param res -教练ID/日期
 */
api.appointment.queryAppointmentCarRecordByDate = res => axios({
  method: 'POST',
  url: '/zjerp/outer/planClassCar/v1/queryAppointmentCarRecordByDate',
  data: res
});

/**
 * @name 学员约车
 * @param data
 */
api.appointment.addAppointmentCarRecord = data => axios({
  method: 'POST',
  url: '/zjerp/outer/appointmentCarRecord/v1/addAppointmentCarRecord',
  data
});

/**
 * @name 查询约车排班规则
 */
api.appointment.queryPlanClassRuleDetail = res => axios({
  method: 'GET',
  url: '/zjerp/outer/planClassCar/v1/queryPlanClassRuleDetail'
});

/**
 * @name 分页查询约车记录
 */
api.appointment.getUserAppointmentCarRecord = res => axios({
  method: 'POST',
  url: '/zjerp/outer/appointmentCarRecord/v1/getUserAppointmentCarRecord',
  data: res
});

/**
 * @name 用户取消约车
 * @param res -约车记录ID
 */
api.appointment.cancelAppointment = res => axios({
  method: 'GET',
  url: '/zjerp/outer/appointmentCarRecord/v1/cancelAppointment',
  params: res
});

/**
 * @name 根据约车记录查询教学日志
 * @param res -约车记录ID
 */
api.appointment.getAppointmentTeachLogByAppointId = res => axios({
  method: 'GET',
  url: '/zjerp/outer/appointmentCarRecord/v1/getAppointmentTeachLogByAppointId',
  params: res
});

/**
 * @name 用户取消约车，取爽约提示
 * @param res -约车记录ID
 */
api.appointment.getCancelAppointmentMsg = res => axios({
  method: 'GET',
  url: '/zjerp/outer/appointmentCarRecord/v1/getCancelAppointmentMsg',
  params: res
});

export default api;
